import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme?.spacing?.lg || '24px'};
  padding: ${(props) => props.theme?.spacing?.lg || '24px'};
  min-height: 100%;
  width: 100%;
`;
